import React from "react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import { useState, useEffect } from "react";
import PageNavigation from "./page";

// Fetching Data from the API]

// End

// Page Html
export default function DoubleAnswer() {
  const [doubleAnswerData, setDoubleAnswerData] = useState({
    data: [],
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDoubleAnswerData = async () => {
      try {
        const response = await fetch("/api/questions/doubleanswer", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setDoubleAnswerData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch DoubleAnswer data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching DoubleAnswer data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchDoubleAnswerData();
  }, []); // Empty dependency array to fetch data only once on mount

  // End

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <PageNavigation heading="Multiple Type Double Answer" id={doubleAnswerData.data} />

    </div>
  );
}
